import React from "react";
import { ImageSlider } from "./ImageSlider";

const lodgingImages = [
  {
    src: "/smestaj1.jpg",
    alt: "Smeštaj u rustičnom ambijentu",
    caption: "Udobne sobe sa toplim drvenim tonovima i prirodnim tekstilom."
  },
  {
    src: "/smestaj2.jpg",
    alt: "Detalj smeštaja",
    caption: "Pažljivo birana posteljina za miran i udoban san."
  },
  {
    src: "/smestaj3.jpg",
    alt: "Prostor za odmor",
    caption: "Prostrani apartmani za duže boravke i porodična putovanja."
  }
];

export function LodgingSection() {
  return (
    <section className="section section-alt lodging-page">
      <div className="lodging-inner">
        <header className="section-header">
          <p className="section-eyebrow">Smeštaj</p>
          <h1 className="section-title">Prijatnost i udobnost na jednom mestu</h1>
          <div className="section-subtitle">
            <p>
              Naše prenoćište nudi udoban i kvalitetan smeštaj sa ukupno 27
              ležajeva, raspoređenih u dvokrevetnim i trokrevetnim sobama, kao i u
              prostranom trosobnom apartmanu namenjenom za do 5 osoba.
            </p>
            <p>
              Sve smeštajne jedinice opremljene su sopstvenim kupatilom, grejanjem
              i klima uređajem, kako bi vaš boravak bio prijatan tokom cele godine.
              Gostima su na raspolaganju i hotelski sadržaji poput šampona, kupke,
              tečnog sapuna, peškira i sobnih papuča, što dodatno doprinosi osećaju
              komfora.
            </p>
            <p>
              Kvalitet smeštaja potvrđen je i kategorizacijom od 4 zvezdice, što
              garantuje visok standard usluge i udobnosti.
            </p>
            <p>
              Bilo da dolazite na kraći odmor ili duži boravak, kod nas vas
              očekuje potpuna udobnost i opuštanje.
            </p>
          </div>
        </header>
      </div>

      <div className="slider-fullbleed">
        <ImageSlider images={lodgingImages} auto interval={6500} />
      </div>

      <div className="lodging-inner lodging-inner--after-slider">
        <div className="lodging-copy-block">
          <h2 className="lodging-copy-title">
            Sobe sa toplinom doma i savremenim komforom
          </h2>
          <p>
            Naš smeštaj spaja prijatnu atmosferu i funkcionalnost, pružajući vam
            sve što je potrebno za ugodan boravak – od kvalitetnih materijala i
            udobnih kreveta, do brzog Wi-Fi interneta, klima uređaja i potpune
            privatnosti.
          </p>
          <ul className="feature-list">
            <li>Besplatan parking za goste smeštaja</li>
            <li>Mogućnost kasne prijave uz prethodnu najavu</li>
            <li>Doručak u restoranu ili sobi</li>
          </ul>
          <a href="tel:034354571" className="btn btn-outline lodging-cta">
            POZOVITE NAS
          </a>
        </div>
      </div>
    </section>
  );
}
